import styled from '@emotion/styled'
import { colors, fontSize, fontWeight, spacing } from '@retailer-platform/shared-components'
import React, { type FunctionComponent } from 'react'
import { useDomainMessage } from 'domains/products/utils/domain/intl'
import missingImage from 'domains/products/assets/missing-image.png'

interface ProductsViewImageProps {
  url?: string
  label?: string
}

const Label = styled.div({
  fontSize: fontSize.X12,
  fontWeight: fontWeight.BOLD,
  marginBottom: spacing.X8,
})

const ImageContainer = styled.div<ProductsViewImageProps>(
  {
    width: 150,
    height: 150,
    borderColor: colors.GRAYSCALE.X20,
    borderWidth: 1,
    borderStyle: 'solid',
    img: {
      width: 148,
      height: 148,
      objectFit: 'contain',
    },
  },
  ({ url }) => {
    if (url) return

    return {
      backgroundImage: `url(${missingImage})`,
      backgroundPosition: 'center center',
      backgroundRepeat: 'no-repeat',
      borderStyle: 'dashed',
    }
  }
)

export const ProductsViewImage: FunctionComponent<ProductsViewImageProps> = props => {
  const notProvided = useDomainMessage('productsDomain.view.details.sections.images.notProvided')
  const title = [props.label].filter(Boolean)
  if (!props.url) title.push(`(${notProvided})`)

  return (
    <div>
      {props.label && <Label>{props.label}</Label>}

      <ImageContainer
        {...props}
        title={title.join(' ')}
        data-testid="products-view-image-container"
      >
        {props.url && <img src={props.url} />}
      </ImageContainer>
    </div>
  )
}
